import { useCallback, useEffect, useState } from "react";
import type { WorkspaceSetupProgress } from "@crewledger/shared/workspace";
import { apiFetch } from "@/lib/api";

interface SetupState {
  data: WorkspaceSetupProgress | null;
  loading: boolean;
  error: string | null;
}

export function useWorkspaceSetup() {
  const [state, setState] = useState<SetupState>({
    data: null,
    loading: true,
    error: null,
  });

  const refresh = useCallback(async () => {
    setState((prev) => ({ ...prev, loading: true, error: null }));
    try {
      const response = await apiFetch<{ data: WorkspaceSetupProgress }>("/api/dashboard/setup");
      setState({ data: response.data, loading: false, error: null });
    } catch (err) {
      setState({
        data: null,
        loading: false,
        error: err instanceof Error ? err.message : "Failed to load setup status",
      });
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { ...state, refresh };
}
